import { Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { GenericService } from '../../../../services/generic.services';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { SportsService } from '../../../../services/sport.service';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ScoresFootballTeamComponent } from '../../../../components/shared/scores-football-team/scores-football-team.component';
import { ScoresSportsTeamComponent } from '../../../../components/shared/scores-sports-team/scores-sports-team.component';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-today-matches',
  standalone: true,
  imports: [
    NzSkeletonComponent,
    CommonModule,
    TranslateModule,
    ScoresFootballTeamComponent,
    ScoresSportsTeamComponent,
    NoResultComponent
  ],
  templateUrl: './today-matches.component.html',
  styleUrl: './today-matches.component.scss',
})
export class TodayMatchesComponent {
  @Input() idCompetition: string = '';
  @Input() type: string = 'Competition';
  @Input() hasFavoriteSport: string = '';

  dashboardToday: Array<any> = [];
  filterSelected: any = 'All';
  loaderMatches = true;
  dateSelected: string = '';

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  constructor(
    private scoresServices: ScoresSportsService,
    public utilityService: UtilitiesService,
    public readonly sportsServices: SportsService,
    public readonly genericSrevices: GenericService
  ) {
    this.dateSelected = genericSrevices.getCurrentDate();
  }

  ngOnChanges(): void {
    this.loaderMatches = true;
    this.loadInfoMatchesCompetition(this.idCompetition, this.dateSelected);
  }

  private loadInfoMatchesCompetition(id: string, date: string) {
    this.dashboardToday = [];
    this.scoresServices
      .getScheduleResultsById(
        date,
        'All',
        id,
        this.type,
        true,
        this.hasFavoriteSport
      )
      .subscribe(
        (response: any) => {
          if (response.status) {
            this.dashboardToday = this.hasFavoriteSport
              ? response.data.map((res: any) => ({ ...res, favorite: true }))
              : response.data;
            setTimeout(() => {
              this.loaderMatches = false;
            }, 1000);
          } else this.loaderMatches = false;
        },
        () => {
          this.loaderMatches = false;
        }
      );
  }
}
